import React from 'react';
import { observer } from 'mobx-react';

import PageComponent from 'js/components/pages/PageComponent';
import AppContent from 'js/components/AppContent';
import { lightGrey1Color } from 'js/config/style';
import { url } from 'js/services/Network';

import Modal from 'js/components/core/Modal';
import Constraint from 'js/components/Constraint';
import Backdrop from 'js/components/core/Backdrop';
import ErrorDisplay from 'js/components/common/ErrorDisplay';
import Button, { buttonHeight } from 'js/components/common/Button';

import Title from 'js/components/core/SteppedPage/Title';
import SubTitle from 'js/components/core/SteppedPage/SubTitle';
import Summary from './Summary';
import Payment from './Payment';

import TokenLabelPageState from 'js/stores/pages/TokenLabelPageState';
import IPAddressesMatchNotification from "js/components/pages/ManageOrderPage/IPAddressesMatchNotification";

@observer
export default class TokenLabelPage extends PageComponent {
  pageName = 'TokenLabelPage';
  pageColor = lightGrey1Color;
  page = TokenLabelPageState.create({
    alias: this.props.alias,
  });

  backNav = () => ({
    mode: 'back',
    text: this.page.purchase_token.title,
    url: url('status-page', this.page),
  });

  bootstrap = () => this.page.load();

  renderPage() {
    const page = this.page;
    return (
      <AppContent padded>
        <Backdrop offset={`${buttonHeight / 2}rem`}>
          <Constraint>
            <Title>Print label</Title>
            <SubTitle>Click the button to accept the offer and print the shipping label.</SubTitle>
            <Summary />
          </Constraint>
        </Backdrop>

        <Constraint offset={`${buttonHeight / 2}rem`}>
          <Button disabled={!page.canSubmit} onClick={page.submit} isLoading={page.isSubmitting}>
            Print label
          </Button>
          <ErrorDisplay>{page.error}</ErrorDisplay>
        </Constraint>

        <Modal showModal={page.ipAddressesMatchModalIsVisible} onCancel={page.closeModal} withCloseButton>
          <IPAddressesMatchNotification onSubmit={page.closeIpAddressesMatchModal}/>
        </Modal>

        <Modal showModal={page.modalIsVisible} onCancel={page.closeModal} withCloseButton>
          <Payment />
        </Modal>
      </AppContent>
    );
  }
}
